import React, { useContext } from 'react';

import ROUTES from '../../routes';
import Link from '../Link';
import Logo from '../Logo';

import Button from '@components/Button';
import { HeaderCTA } from '@components/HeaderNew';
import { Context } from '@contexts/AppContext';

const HeaderSimple = ({
  align = 'center',
  cta = false,
  secondaryCta = false,
}) => {
  const { isLoggedIn } = useContext(Context);

  return (
    <>
      <header
        className={`bg-white shadow-header h-[52px] flex items-center px-8`}
      >
        <div
          className={`w-full max-w-6xl mx-auto flex ${
            cta && 'justify-between'
          }`}
        >
          <div className={`text-${align} pt-2`}>
            <div className="inline-block">
              <Link href="/">
                <a className="transition-opacity hover:opacity-80 text-black dark:text-white">
                  <Logo />
                </a>
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {isLoggedIn ? (
              <>
                <Button
                  href={ROUTES.account}
                  className="hidden lg:flex"
                  size="sm"
                  variant="ghost"
                >
                  <span className="font-medium">Account</span>
                </Button>
                <HeaderCTA isLoggedIn={isLoggedIn} />
              </>
            ) : (
              <>
                {secondaryCta && (
                  <Button
                    variant="ghost"
                    size="sm"
                    href={secondaryCta.href}
                    onClick={secondaryCta.onClick}
                  >
                    {secondaryCta.text}
                  </Button>
                )}

                {cta && (
                  <Button href={cta.href} onClick={cta.onClick} size="sm">
                    {cta.text}
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderSimple;
